
const initialState = {
    detectorResolutionX: 800,
    detectorResolutionY: 800,
    detectorDimensionX: 400,
    detectorDimensionY: 400,
    distanceSourceDetector: 1167,
    distanceSourceObject: 580,
    stlFile: "Plastic-Metal-Cube",
    objectOrientationPsi: 0.0,
    objectOrientationPhi: 0.0,
    objectOrientationTheta: 45.0,
    objectDisplacementX: 0.0,
    objectDisplacementY: 0.0,
    objectDisplacementZ: 0.0,
    systemRotationRangeLower: 0.0,
    systemRotationRangeUpper: 180.0,
    systemRotationNumberSteps: 1600,
    sourceMaterial: "Tungsten",
    sourceThickness: 6,
    sourceFilterMaterial: "Aluminum (1 mm)",
    sourceEnergy: 75000,
}



//-----------------------------------------------------------------



const reducer = (state = initialState, action) => {
    switch (action.type) {

        case "SIMULATION-PARAM:DETECTOR-RESOLUTION-X":
            console.log("SimParam: Detector-Resolution X");
            return Object.assign({}, state, {
                detectorResolutionX: action.value,
            });

        case "SIMULATION-PARAM:DETECTOR-RESOLUTION-Y":
            console.log("SimParam: Detector-Resolution Y");
            return Object.assign({}, state, {
                detectorResolutionY: action.value,
            });

        case "SIMULATION-PARAM:DETECTOR-DIMENSION-X":
            console.log("SimParam: Detector-Dimension X");
            return Object.assign({}, state, {
                detectorDimensionX: action.value,
            });

        case "SIMULATION-PARAM:DETECTOR-DIMENSION-Y":
            console.log("SimParam: Detector-Dimension Y");
            return Object.assign({}, state, {
                detectorDimensionY: action.value,
            });

        case "SIMULATION-PARAM:DISTANCE-SOURCE-DETECTOR":
            console.log("SimParam: Distance Source-Detector");
            return Object.assign({}, state, {
                distanceSourceDetector: action.value,
            });

        case "SIMULATION-PARAM:DISTANCE-SOURCE-OBJECT":
            console.log("SimParam: Distance Source-Object");
            return Object.assign({}, state, {
                distanceSourceObject: action.value,
            });

        case "SIMULATION-PARAM:STL-FILE":
            console.log("SimParam: STL");
            return {...state, stlFile: action.value};

        case "SIMULATION-PARAM:OBJECT-ORIENTATION-PSI":
            console.log("SimParam: Object Orientation Psi");
            return Object.assign({}, state, {
                objectOrientationPsi: action.value,
            });
        
        case "SIMULATION-PARAM:OBJECT-ORIENTATION-PHI":
            console.log("SimParam: Object Orientation Phi");
            return Object.assign({}, state, {
                objectOrientationPhi: action.value,
            });

        case "SIMULATION-PARAM:OBJECT-ORIENTATION-THETA":
            console.log("SimParam: Object Orientation Theta");
            return Object.assign({}, state, {
                objectOrientationTheta: action.value,
            });

        case "SIMULATION-PARAM:OBJECT-DISPLACEMENT-X":
            console.log("SimParam: Object Displacement X");
            return Object.assign({}, state, {
                objectDisplacementX: action.value,
            });
        
        case "SIMULATION-PARAM:OBJECT-DISPLACEMENT-Y":
            console.log("SimParam: Object Displacement Y");
            return Object.assign({}, state, {
                objectDisplacementY: action.value,
            });

        case "SIMULATION-PARAM:OBJECT-DISPLACEMENT-Z":
            console.log("SimParam: Object Displacement Z");
            return Object.assign({}, state, {
                objectDisplacementZ: action.value,
            });

        case "SIMULATION-PARAM:SYSTEM-ROTATION-RANGE-LOWER":
            console.log("SimParam: System Rotation Range Lower");
            return Object.assign({}, state, {
                systemRotationRangeLower: action.value,
            });
        
        case "SIMULATION-PARAM:SYSTEM-ROTATION-RANGE-UPPER":
            console.log("SimParam: System Rotation Range Upper");
            return Object.assign({}, state, {
                systemRotationRangeUpper: action.value,
            });

        case "SIMULATION-PARAM:SYSTEM-ROTATION-NUMBER-STEPS":
            console.log("System Rotation Steps");
            return Object.assign({}, state, {
                systemRotationNumberSteps: action.value,
            });

        case "SIMULATION-PARAM:SOURCE-MATERIAL":
            console.log("SimParam: Source Material");
            return Object.assign({}, state, {
                sourceMaterial: action.value,
            });

        case "SIMULATION-PARAM:SOURCE-THICKNESS":
            console.log("SimParam: Source Thickness");
            return Object.assign({}, state, {
                sourceThickness: action.value,
            });

        case "SIMULATION-PARAM:SOURCE-FILTER-MATERIAL":
            console.log("SimParam: Source Filter Material");
            return Object.assign({}, state, {
                sourceFilterMaterial: action.value,
            });

        case "SIMULATION-PARAM:SOURCE-ENERGY":
            console.log("SimParam: Source Energy");
            return Object.assign({}, state, {
                sourceEnergy: action.value,
            });

        default:
            return state;
    }
}

export { reducer }
